import { Navigate, Route, Routes } from 'react-router-dom'

import { appRoles } from '../config.tsx'
import RouteGuard from './RouteGuard.tsx'

import { InstructorList } from '../../pages/02_dozent_(intern)/InstructorList.tsx'
import _eventRoutes from '../../pages/01_events/_eventRoutes.tsx'
import Profile from '../../pages/03_Register_Profile/Profile.tsx'
import UploadPage from '../../pages/04_upload/uploadPage.tsx'
import useUserRoles from '../../hooks/useUserRoles.tsx'


const Pages = () => {
  const { isInternal } = useUserRoles()

  return (
    <Routes>
      <Route>
        Mein Dashboard
        {/*Bei einem interner Mitarbeiter ist der Start die Instructor Seite.*/}
        {isInternal ? (
          <Route
            path="/"
            element={
              <RouteGuard roles={[appRoles.Intern]}>
                <Navigate to={'/instructors'} />
              </RouteGuard>
            }
          />
        ) : (<Route
          path="/"
          element={
            <RouteGuard roles={[appRoles.Dozent, appRoles.Intern]}>
              <Navigate to={'/seminare'} />
            </RouteGuard>
          }
        />)}

        {/* Dozenten Liste */}
        <Route
          path="/instructors"
          element={
            <RouteGuard roles={[appRoles.Intern]}>
              <InstructorList />
            </RouteGuard>
          }
        />
        {/* Profil: redirect */}
        <Route
          path="/profile/"
          element={
            <RouteGuard roles={[appRoles.Intern]}>
              <Profile />
            </RouteGuard>
          }
        />
        {/* Profil: Detail */}
        <Route
          path="/profile/:sub"
          element={
            <RouteGuard roles={[appRoles.Intern]}>
              <Profile />
            </RouteGuard>
          }
        />
        {/* Veranstaltungen */}
        <Route
          path="/seminare/*"
          element={
            <RouteGuard roles={[appRoles.Dozent, appRoles.Intern]}>
              <_eventRoutes />
            </RouteGuard>
          }
        />
        {/* Upload */}
        <Route
          path="/upload/*"
          element={
            <RouteGuard roles={[appRoles.Dozent, appRoles.Intern]}>
              <UploadPage />
            </RouteGuard>
          }
        />
        {/* Ausschreibungen */}
        {/* <Route
          path="/ausschreibungen"
          element={
            <RouteGuard roles={[appRoles.Dozent, appRoles.Intern]}>
              <OpenSeminars />
            </RouteGuard>
          }
        /> */}
        {/* Themenvorschlag */}
        {/* <Route
          path="/themenvorschlag"
          element={
            <RouteGuard roles={[appRoles.Dozent, appRoles.Intern]}>
              <TopicSuggest />{' '}
            </RouteGuard>
          }
        /> */}
        {/*Passwort ändern */}
        {/* <Route
          path="/passwort-aendern"
          element={
            <RouteGuard roles={[appRoles.Anonym]}>
              <PasswordChange />
            </RouteGuard>
          }
        /> */}
      </Route>
    </Routes>
  )
}

export default Pages
